import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('cameras');

const state = {
  cameraSearchResults: [],
  currentCamera: {},
};

const getters = {
  cameraSearchResults: (state) => state.cameraSearchResults,
  currentCamera: (state) => state.currentCamera,
};

const mutations = {
  setCameraSearchResults: (state, cameraSearchResults) => {
    state.cameraSearchResults = cameraSearchResults;
  },
  updateCameraSearchResults: (state, task) => {
    const index = state.cameraSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.cameraSearchResults, index, task);
  },
  removeFromCameraSearchResults: (state, id)=>{
    state.cameraSearchResults.data = state.cameraSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.cameraSearchResults.total--;
  },
  setCurrentCamera: (state, currentCamera) => {
    state.currentCamera = currentCamera;
  },
};

const actions = {
  async searchCameras({commit}, query) {
    const response = await API.search(query);
    commit('setCameraSearchResults', response.data);
    return response.data;
  },
  async loadCamera({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentCamera', response.data);
    return response.data;
  },
  async createCamera({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateCamera({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    commit('updateCameraSearchResults', response.data);
    return response.data;
  },
  async deleteCamera({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromCameraSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
